(function($){
    $(document).ready(function() {
        var HistorySliderInit = function(elem,sliderPaprms,fancyPaprams) {
            var self = this;
            this.wrapper = elem;
            this.sliderParams = sliderPaprms || {};
            this.fancyParams = fancyPaprams || {};
            this.banners = this.wrapper.find('.slide');

            this._sliderInit = function() {
                self.wrapper.slick(this.sliderParams);
            };

            this._fancyInit = function() {
                self.banners.fancybox(this.fancyParams);
            };

            this.init = function() {
                self._sliderInit();
                self._fancyInit();
            };
            this.init();
        };

        var historySlider = new HistorySliderInit($(".history-slider"),{
            slidesToShow: 4,
            autoplay:false,
            dots:false,
            fade:false,
            prevArrow:'<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow:'<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            speed:300,
            infinite: false,
            adaptiveHeight:true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows:false
                }
            }]
        },{
            openEffect	: 'none',
            closeEffect	: 'none',
            loop : false,
            beforeShow : function(){
                this.title = $(this.element).find('.slider-caption').html();
            },
            helpers: {
                title : {
                    type : 'inside'
                }
            },
            afterLoad: function(current, previous) {
                historySlider.wrapper.slick("slickGoTo", $(this.element).data('slick-index'));
                if (previous) {
                    if(current.index > previous.index) {
                        historySlider.wrapper.find('.slick-arrow.slick-next').trigger('click');
                    } else {
                        historySlider.wrapper.find('.slick-arrow.slick-prev').trigger('click');
                    }
                }
            }
        });
    });
})(jQuery);

